<template>
  <div class="how--bg">
    <div class="how--color">
      <div class="how container">
          <div class="how__img">
            <img
              src="../../assets/fylo-two-columns-landing/illustration-1.svg"
              alt="bottom-illustration"
            />
          </div>
          <div class="how__content">
            <h3 class="how__title">
              Stay productive, wherever you are
            </h3>
            <p class="how__text">
              Never let location be an issue when accessing your files. Fylo has you
              covered for all of your file storage needs.
            </p>
            <p class="how__text">
              Securely share files and folders with friends, family and colleagues
              for live collaboration. No email attachments required!
            </p>
            <div class="how__link">
              <a href="#">See how Fylo works </a>
              <img src="../../assets/fylo-two-columns-landing/icon-arrow.svg" alt="link-arrow" />
            </div>
            <Quote />
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import Quote from './Quotes.vue';

export default {
  name: 'How',
  components: {
    Quote,
  },
};
</script>

<style lang="scss" scoped>
  .how {

   &--bg {
      background: no-repeat url(../../assets/fylo-two-columns-landing/bg-curve-mobile.svg);
      background-size: contain;
      background-position: top 0 left;
      padding-top: 6.5rem;
      margin-top: calc(var(--bg-spacer) * 2);

      @media (min-width: 25em) {
        padding-top: 3rem;
      }

      @media (min-width: 40em) {
        padding-top: 5rem;
      }

      @media (min-width: 60em) {
        padding-top: 7rem;
      }

      @media (min-width: 90em) {
        background: no-repeat url(../../assets/fylo-two-columns-landing/bg-curve-desktop.svg);
        background-size: contain;
        background-position: top 0 left;
        padding-top: 7rem;
      }

      @media (min-width: 120em) {
        padding-top: 8rem;
      }
    }

    &--color {
      background-color: var(--light-grayish-blue);
      padding: var(--bg-spacer) 0;
    }

    @media (min-width: 90em) {
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      justify-content: space-between;

      text-align: initial;
    }

    &__img {
      margin-bottom: var(--sm-spacer);
      @media (min-width: 90em) {
        width: 45%;
        margin-bottom: 0;
      }
    }

    &__content {
      max-width: 55ch;
    }

    &__title {
      line-height: 1;
      font-size: var(--fs-h2);
      margin-bottom: calc(var(--sm-spacer) / 1.5);
      font-family: var(--ff-alt);
    }

    &__text {
      color: var(--desaturated-blue);
    }

    &__text + &__text {
      margin-top: calc(var(--sm-spacer) / 2.5);
    }

    &__link {
      display: flex;
      gap: calc(var(--sm-spacer) / 1.5);
      color: var(--moderate-cyan);
      margin-top: var(--sm-spacer);
      border-bottom: 1px solid;
      width: max-content;
      margin: var(--sm-spacer) auto 0;

      transition: all 350ms linear;

      @media (min-width: 90em) {
        margin: calc(var(--sm-spacer) / 2) 0 0;
      }

      img {
        width: 2rem;
      }

      a {
        text-decoration: none;
        color: inherit;
      }

      &:hover {
        opacity: 0.7
      }
    }
  }
</style>
